import { Col, Row } from 'react-bootstrap';
import './PasswordChecklist.scss';
import CheckIcon from './assets/CheckIcon';
import ErrorIcon from './assets/ErrorIcon';
import {
  containsAlphaCharacter,
  containsUserData,
  isPasswordCorrectLength,
  matchesWitchConfirmPassword,
  UserData,
} from './passwordChecks';

interface PasswordChecklistProps {
  password: string;
  confirmPassword: string;
  userData: UserData;
}

const PasswordChecklist = ({ password, confirmPassword, userData }: PasswordChecklistProps) => {
  return (
    <Row className="g-0 password-checklist-container pt-2">
      <Col
        xs={12}
        sm={12}
        md={6}
        xl={12}
        className="g-0"
      >
        <div className="password-checklist-element">
          <div className="check-icon">
            {isPasswordCorrectLength(password) ? <CheckIcon /> : <ErrorIcon />}
          </div>
          <div className="password-checklist-text">12 characters or longer.</div>
        </div>
        <div className="password-checklist-element">
          <div className="check-icon">
            {containsAlphaCharacter(password) ? <CheckIcon /> : <ErrorIcon />}
          </div>
          <div className="password-checklist-text">Contains at least one uppercase character.</div>
        </div>
      </Col>
      <Col
        sm={12}
        md={6}
        xl={12}
        className="g-0"
      >
        <div className="password-checklist-element">
          <div className="check-icon">
            {matchesWitchConfirmPassword(password, confirmPassword) ? <CheckIcon /> : <ErrorIcon />}
          </div>
          <div className="password-checklist-text">Matches with the confirm password.</div>
        </div>
        <div className="password-checklist-element">
          <div className="check-icon">
            {!containsUserData(password, userData) ? <CheckIcon /> : <ErrorIcon />}
          </div>
          <div className="password-checklist-text">Does not contain any provider details.</div>
        </div>
      </Col>
    </Row>
  );
};

export default PasswordChecklist;
